module.exports = __webpack_public_path__ + "img/banner-1.55b8b31c.jpg";